export default "__VITE_ASSET__DIybC8lz__"